import moment from 'moment'
import _ from 'lodash'

export default {
    export: function (list,tableConfigs) {
        require.ensure([], () => {
            const { export_json_to_excel } = require('@/excel/Export2Excel')
            const tHeader = _.pull(_.map(tableConfigs, 'label'),'操作')
            const filterVal = _.pull(_.map(tableConfigs, 'prop'),'operation')
            const data = this.formatJson(filterVal, list)
            const fileName = moment().format('YYYY-MM-DD_HH-mm-ss')
            export_json_to_excel(tHeader, data, fileName)
        })

    },

    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    }
}
